'use client';

// Package Imports
import React from 'react';

// Type Imports
import type { WithContext, Organization } from 'schema-dts';

// Constants Imports
import { strings } from '@/lib/data/site/strings';

const siteUrl = (process.env.NEXT_PUBLIC_SITE_URL ?? '').replace(/\/$/, '');

export const OrganizationSchema = () => {

  const schema: WithContext<Organization> = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: strings.brandName,
    url: siteUrl,
    logo: `${siteUrl}${strings.logo?.primary}`,
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'Customer Service',
        email: strings.supportEmail,
        telephone: strings.phoneNumber,
      },
    ],
    naics: '445310',
    isicV4: '4723',
    location: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '2410 Smith St',
        addressLocality: 'Houston',
        addressRegion: 'TX',
        postalCode: '77006',
        addressCountry: 'US',
      },
    },
  };

  return <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
};
